<template>
  <div>
    <el-dialog v-if="value && visible && !showPasswordDialog" title="安全提示" visible modal :closable="false" width="650px"
               height="150px">
      <div>
        系统检测到您正在使用弱密码，存在密码泄漏的风险！为了您的信息安全，请及时修改您的密码。
      </div>
      <div>新密码建议为包含大小字母、数字和特殊符号，长度8位以上。</div>
      <template #footer>
        <el-button type="primary" @click="openDialog">立即修改</el-button>
        <el-button type="default" :disabled="!closable" @click="close">{{text}}</el-button>
      </template>
    </el-dialog>
    <XPasswordDialog v-if="value && visible" :visible="showPasswordDialog" :checkInit="false"
                     @success="handleModifySuccess"></XPasswordDialog>
  </div>
</template>

<script>
import XPasswordDialog from '@/component/x-password-dialog/x-password-dialog.vue';
import {setWeekPassword} from '@/util/user';

export default {
  components: {
    XPasswordDialog
  },
  props: {
    count: {
      type: Number,
      default: 8
    },
    value: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      counter: 0,
      visible: this.value,
      showPasswordDialog: false
    };
  },
  computed: {
    text() {
      const num = this.count - this.counter;
      return num > 0 ? `关闭（ ${num} ）` : '关闭';
    },
    closable() {
      return this.count - this.counter <= 0;
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.$emit('update:value', false);
      this.visible = false;
    },
    tick() {
      setTimeout(() => {
        if (!this.closable) {
          ++this.counter;
          this.tick();
        }
      }, 1000);
    },
    openDialog() {
      this.showPasswordDialog = true;
    },
    handleModifySuccess() {
      // this.$access?.save({
      //   weekPassword: false
      // });
      setWeekPassword(false);
    }
  },
  mounted() {
    this.tick();
  }
};
</script>

<style>

</style>
